<template>
   <v-dialog width="800px" persistent v-model="deleteDialog">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
      <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Delete Vote</v-card-title>
      <v-card-text>Are you sure you want to delete the record of {{ item.channelName }} ?</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="ma-2"
          color="red darken-2"
          @click="onDeleteChannel"
        >
          <v-icon left>mdi-delete</v-icon>
          Confirm Delete
        </v-btn>
        <v-btn
          class="ma-2"
          color="grey"
          @click="deleteDialog=false"
        >
          <v-icon left>mdi-close</v-icon>
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
   </v-dialog>
</template>

<script>
export default {
  props: ['item'],
  data () {
    return {
      deleteDialog: false
    }
  },
  methods: {
    onDeleteChannel () {
      this.$store.dispatch('deleteChannel', this.item.id)
    }
  }
}
</script>

<style>

</style>
